import Vue from 'vue';
import VueI18n from 'vue-i18n'
import App from "./pages/App.vue";
import Callback from "./pages/Callback.vue";
import NotFound from "./pages/404.vue";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import "./styles.scss";

Vue.use(VueI18n)

const app = new Vue({
	i18n: new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
    silentTranslationWarn: true
  }),
  data: {
    currentRoute: window.location.pathname
  },
	render (h) {
    if (this.currentRoute == "/") {
      return h(App);
    } else if (this.currentRoute.includes("/callback")) {
      return h(Callback)
    }
    return h(NotFound)
  }
}).$mount('#app')

window.document.addEventListener("DOMContentLoaded", function() {
  app.currentRoute = window.location.pathname;
  document.title = app.currentRoute.includes("/callback") ? "Loading..." : "Sachet image read errors";
});

function loadLocaleMessages() {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}
